"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerHDWallet = exports.LedgerHDWalletInfo = void 0;
exports.isLedger = isLedger;
exports.info = info;
exports.create = create;
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const isObject_1 = __importDefault(require("lodash/isObject"));
const btc = __importStar(require("./bitcoin"));
const cosmos = __importStar(require("./cosmos"));
const eth = __importStar(require("./ethereum"));
const mayachain = __importStar(require("./mayachain"));
const solana = __importStar(require("./solana"));
const thorchain = __importStar(require("./thorchain"));
const utils_1 = require("./utils");
function isLedger(wallet) {
    return (0, isObject_1.default)(wallet) && wallet._isLedger;
}
function describeETHPath(path) {
    const pathStr = core.addressNListToBIP32(path);
    const unknown = {
        verbose: pathStr,
        coin: "Ethereum",
        isKnown: false,
    };
    if (path.length !== 5 && path.length !== 4)
        return unknown;
    if (path[0] !== 0x80000000 + 44)
        return unknown;
    if (path[1] !== 0x80000000 + core.slip44ByCoin("Ethereum"))
        return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000)
        return unknown;
    let accountIdx;
    if (path.length === 5) {
        if (path[3] !== 0)
            return unknown;
        if (path[4] !== 0)
            return unknown;
        accountIdx = (path[2] & 0x7fffffff) >>> 0;
    }
    else if (path.length === 4) {
        if (path[2] !== 0x80000000)
            return unknown;
        if ((path[3] & 0x80000000) >>> 0 === 0x80000000)
            return unknown;
        accountIdx = path[3];
    }
    else {
        return unknown;
    }
    return {
        verbose: `Ethereum Account #${accountIdx}`,
        wholeAccount: true,
        accountIdx,
        coin: "Ethereum",
        isKnown: true,
        isPrefork: false,
    };
}
function describeUTXOPath(path, coin, scriptType) {
    const pathStr = core.addressNListToBIP32(path);
    const unknown = {
        verbose: pathStr,
        coin,
        scriptType,
        isKnown: false,
    };
    if (!btc.btcSupportsCoin(coin))
        return unknown;
    if (!btc.btcSupportsScriptType(coin, scriptType))
        return unknown;
    if (path.length !== 3 && path.length !== 5)
        return unknown;
    if ((path[0] & 0x80000000) >>> 0 !== 0x80000000)
        return unknown;
    const purpose = path[0] & 0x7fffffff;
    if (![44, 49, 84].includes(purpose))
        return unknown;
    if (purpose === 44 && scriptType !== core.BTCInputScriptType.SpendAddress)
        return unknown;
    if (purpose === 49 && scriptType !== core.BTCInputScriptType.SpendP2SHWitness)
        return unknown;
    if (purpose === 84 && scriptType !== core.BTCInputScriptType.SpendWitness)
        return unknown;
    const slip44 = core.slip44ByCoin(coin);
    if (slip44 === undefined || path[1] !== 0x80000000 + slip44)
        return unknown;
    const wholeAccount = path.length === 3;
    let script = scriptType
        ? {
            [core.BTCInputScriptType.SpendAddress]: " (Legacy)",
            [core.BTCInputScriptType.SpendP2SHWitness]: "",
            [core.BTCInputScriptType.SpendWitness]: " (Segwit Native)",
        }[scriptType]
        : undefined;
    switch (coin) {
        case "Bitcoin":
        case "Litecoin":
        case "BitcoinGold":
        case "Testnet":
            break;
        default:
            script = "";
    }
    const accountIdx = path[2] & 0x7fffffff;
    if (wholeAccount) {
        return {
            verbose: `${coin} Account #${accountIdx}${script}`,
            accountIdx,
            coin,
            scriptType,
            wholeAccount: true,
            isKnown: true,
            isPrefork: false,
        };
    }
    else {
        const change = path[3] == 1 ? "Change " : "";
        const addressIdx = path[4];
        return {
            verbose: `${coin} Account #${accountIdx}, ${change}Address #${addressIdx}${script}`,
            coin,
            scriptType,
            accountIdx,
            addressIdx,
            wholeAccount: false,
            isChange: path[3] == 1,
            isKnown: true,
            isPrefork: false,
        };
    }
}
class LedgerHDWalletInfo {
    constructor() {
        this._supportsBTCInfo = true;
        this._supportsETHInfo = true;
        this._supportsThorchainInfo = true;
        this._supportsMayachainInfo = true;
        this._supportsCosmosInfo = true;
        this._supportsSolanaInfo = true;
    }
    getVendor() {
        return "Ledger";
    }
    btcSupportsCoin(coin) {
        return __awaiter(this, void 0, void 0, function* () {
            return btc.btcSupportsCoin(coin);
        });
    }
    btcSupportsScriptType(coin, scriptType) {
        return __awaiter(this, void 0, void 0, function* () {
            return btc.btcSupportsScriptType(coin, scriptType);
        });
    }
    btcSupportsSecureTransfer() {
        return __awaiter(this, void 0, void 0, function* () {
            return btc.btcSupportsSecureTransfer();
        });
    }
    btcSupportsNativeShapeShift() {
        return btc.btcSupportsNativeShapeShift();
    }
    btcGetAccountPaths(msg) {
        return btc.btcGetAccountPaths(msg);
    }
    ethSupportsNetwork(chain_id) {
        return __awaiter(this, void 0, void 0, function* () {
            return eth.ethSupportsNetwork(chain_id);
        });
    }
    ethSupportsSecureTransfer() {
        return __awaiter(this, void 0, void 0, function* () {
            return eth.ethSupportsSecureTransfer();
        });
    }
    ethSupportsNativeShapeShift() {
        return eth.ethSupportsNativeShapeShift();
    }
    ethSupportsEIP1559() {
        return __awaiter(this, void 0, void 0, function* () {
            return eth.ethSupportsEIP1559();
        });
    }
    ethGetAccountPaths(msg) {
        return eth.ethGetAccountPaths(msg);
    }
    thorchainGetAccountPaths(msg) {
        const slip44 = core.slip44ByCoin("Thorchain");
        return [{ addressNList: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + msg.accountIdx, 0, 0] }];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    thorchainNextAccountPath(msg) {
        return undefined;
    }
    mayachainGetAccountPaths(msg) {
        const slip44 = core.slip44ByCoin("Mayachain");
        return [{ addressNList: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + msg.accountIdx, 0, 0] }];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    mayachainNextAccountPath(msg) {
        return undefined;
    }
    cosmosGetAccountPaths(msg) {
        const slip44 = core.slip44ByCoin("Atom");
        return [{ addressNList: [0x80000000 + 44, 0x80000000 + slip44, 0x80000000 + msg.accountIdx, 0, 0] }];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    cosmosNextAccountPath(msg) {
        return undefined;
    }
    solanaGetAccountPaths(msg) {
        return core.solanaGetAccountPaths(msg);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    solanaNextAccountPath(msg) {
        throw new Error("Method not implemented");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hasNativeShapeShift(srcCoin, dstCoin) {
        return false;
    }
    supportsBip44Accounts() {
        return true;
    }
    supportsOfflineSigning() {
        return true;
    }
    supportsBroadcast() {
        return false;
    }
    hasOnDeviceDisplay() {
        return true;
    }
    hasOnDevicePassphrase() {
        return true;
    }
    hasOnDevicePinEntry() {
        return true;
    }
    hasOnDeviceRecovery() {
        return true;
    }
    describePath(msg) {
        switch (msg.coin) {
            case "Ethereum":
                return describeETHPath(msg.path);
            case "Atom":
                return core.cosmosDescribePath(msg.path);
            case "Thorchain":
                return core.thorchainDescribePath(msg.path);
            case "Mayachain":
                return core.mayachainDescribePath(msg.path);
            case "Solana":
                return core.solanaDescribePath(msg.path);
            default:
                return describeUTXOPath(msg.path, msg.coin, msg.scriptType);
        }
    }
    btcNextAccountPath(msg) {
        const description = describeUTXOPath(msg.addressNList, msg.coin, msg.scriptType);
        if (!description.isKnown) {
            return undefined;
        }
        const addressNList = msg.addressNList;
        if (addressNList[0] === 0x80000000 + 44 ||
            addressNList[0] === 0x80000000 + 49 ||
            addressNList[0] === 0x80000000 + 84) {
            addressNList[2] += 1;
            return Object.assign(Object.assign({}, msg), { addressNList });
        }
        return undefined;
    }
    ethNextAccountPath(msg) {
        const addressNList = msg.hardenedPath.concat(msg.relPath);
        const description = describeETHPath(addressNList);
        if (!description.isKnown) {
            return undefined;
        }
        if (description.wholeAccount) {
            addressNList[2] += 1;
            return Object.assign(Object.assign({}, msg), { addressNList, hardenedPath: core.hardenedPath(addressNList), relPath: core.relativePath(addressNList) });
        }
        if (addressNList.length === 5) {
            addressNList[2] += 1;
            return Object.assign(Object.assign({}, msg), { hardenedPath: core.hardenedPath(addressNList), relPath: core.relativePath(addressNList) });
        }
        if (addressNList.length === 4) {
            addressNList[3] += 1;
            return Object.assign(Object.assign({}, msg), { hardenedPath: core.hardenedPath(addressNList), relPath: core.relativePath(addressNList) });
        }
        return undefined;
    }
}
exports.LedgerHDWalletInfo = LedgerHDWalletInfo;
class LedgerHDWallet extends LedgerHDWalletInfo {
    constructor(transport) {
        super();
        this._supportsBTC = true;
        this._supportsETH = true;
        this._supportsEthSwitchChain = false;
        this._supportsAvalanche = true;
        this._supportsOptimism = true;
        this._supportsBSC = true;
        this._supportsPolygon = true;
        this._supportsGnosis = true;
        this._supportsArbitrum = true;
        this._supportsArbitrumNova = true;
        this._supportsBase = true;
        this._supportsThorchain = true;
        this._supportsMayachain = true;
        this._supportsCosmos = true;
        this._supportsSolana = true;
        this._isLedger = true;
        this.transport = transport;
        this.info = new LedgerHDWalletInfo();
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    isInitialized() {
        return __awaiter(this, void 0, void 0, function* () {
            // AFAICT, there isn't an API to figure this out, so we go with a reasonable
            // (ish) default:
            return true;
        });
    }
    getDeviceID() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.transport.getDeviceID();
        });
    }
    getFeatures() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.transport.call(null, "getDeviceInfo");
            (0, utils_1.handleError)(res, this.transport);
            return res.payload;
        });
    }
    /**
     * Validate if a specific app is open
     * Throws WrongApp error if app associated with coin is not open
     * @param coin  Name of coin for app name lookup ie "BitcoinCash"
     */
    validateCurrentApp(coin) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!coin) {
                throw new Error(`No coin provided`);
            }
            const appName = (0, utils_1.coinToLedgerAppName)(coin);
            if (!appName) {
                throw new Error(`Unable to find associated app name for coin: ${coin}`);
            }
            const res = yield this.transport.call(null, "getAppAndVersion");
            (0, utils_1.handleError)(res, this.transport);
            const { payload: { name: currentApp }, } = res;
            if (currentApp !== appName) {
                throw new core.WrongApp("Ledger", appName);
            }
        });
    }
    /**
     * Prompt user to open given app on device
     * User must be in dashboard
     * @param appName - human-readable app name i.e. "Bitcoin Cash"
     */
    openApp(appName) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.transport.call(null, "openApp", appName);
            (0, utils_1.handleError)(res, this.transport);
        });
    }
    getFirmwareVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            const { version } = yield this.getFeatures();
            return version;
        });
    }
    getModel() {
        return __awaiter(this, void 0, void 0, function* () {
            const { device: { productName }, } = this.transport;
            return productName;
        });
    }
    getLabel() {
        return __awaiter(this, void 0, void 0, function* () {
            return "Ledger";
        });
    }
    isLocked() {
        return __awaiter(this, void 0, void 0, function* () {
            return true;
        });
    }
    clearSession() {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    getPublicKeys(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.transport.call(null, "getAppAndVersion");
            (0, utils_1.handleError)(res, this.transport);
            const { payload: { name }, } = res;
            const btcApps = new Set(btc.supportedCoins.map((x) => (0, utils_1.coinToLedgerAppName)(x)).filter((x) => x !== undefined));
            if (btcApps.has(name))
                return btc.btcGetPublicKeys(this.transport, msg);
            switch (name) {
                case "Ethereum":
                    return eth.ethGetPublicKeys(this.transport, msg);
                default:
                    throw new Error(`getPublicKeys is not supported with the ${name} app`);
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loadDevice(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    // Ledger doesn't have this, faking response here
    ping(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            return { msg: msg.msg };
        });
    }
    cancel() {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    recover(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    reset(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendCharacter(character) {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendPassphrase(passphrase) {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendPin(pin) {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendWord(word) {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    wipe() {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    btcGetAddress(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp(msg.coin);
            return btc.btcGetAddress(this.transport, msg);
        });
    }
    btcSignTx(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp(msg.coin);
            return btc.btcSignTx(this, this.transport, msg);
        });
    }
    btcSignMessage(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp(msg.coin);
            return btc.btcSignMessage(this, this.transport, msg);
        });
    }
    btcVerifyMessage(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            return btc.btcVerifyMessage(msg);
        });
    }
    ethSignTx(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Ethereum");
            return eth.ethSignTx(this.transport, msg);
        });
    }
    ethGetAddress(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Ethereum");
            return eth.ethGetAddress(this.transport, msg);
        });
    }
    ethSignMessage(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Ethereum");
            return eth.ethSignMessage(this.transport, msg);
        });
    }
    ethSignTypedData(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Ethereum");
            return eth.ethSignTypedData(this.transport, msg);
        });
    }
    ethVerifyMessage(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            return eth.ethVerifyMessage(msg);
        });
    }
    thorchainGetAddress(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Thorchain");
            return thorchain.thorchainGetAddress(this.transport, msg);
        });
    }
    thorchainSignTx(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Thorchain");
            return thorchain.thorchainSignTx(this.transport, msg);
        });
    }
    mayachainGetAddress(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Thorchain");
            return mayachain.mayachainGetAddress(this.transport, msg);
        });
    }
    mayachainSignTx(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Thorchain");
            return mayachain.mayachainSignTx(this.transport, msg);
        });
    }
    cosmosGetAddress(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Atom");
            return cosmos.cosmosGetAddress(this.transport, msg);
        });
    }
    cosmosSignTx(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Atom");
            return cosmos.cosmosSignTx(this.transport, msg);
        });
    }
    solanaGetAddress(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Solana");
            return solana.solanaGetAddress(this.transport, msg);
        });
    }
    solanaSignTx(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validateCurrentApp("Solana");
            return solana.solanaSignTx(this.transport, msg);
        });
    }
    disconnect() {
        return this.transport.disconnect();
    }
}
exports.LedgerHDWallet = LedgerHDWallet;
function info() {
    return new LedgerHDWalletInfo();
}
function create(transport) {
    return new LedgerHDWallet(transport);
}
//# sourceMappingURL=ledger.js.map